import { PropsWithChildren } from "react";

import styles from "../../timeseries-chart/timeseries-chart.module.css";

type ChartEmptyProps = PropsWithChildren;

export function ChartEmpty({ children }: ChartEmptyProps) {
  return <div className={styles["TimeseriesChartOverlay"]}>{children}</div>;
}

export function isChartEmptyComponent(component: unknown): boolean {
  return (
    typeof component === "object" &&
    component !== null &&
    "type" in component &&
    typeof component.type === "function" &&
    component.type !== null &&
    "name" in component.type &&
    typeof component.type.name === "string" &&
    component.type.name === "ChartEmpty"
  );
}
